<label class="mpp-toggle-button__container">
  <input type="checkbox" class="mpp-toggle-button__control" [formControl]="control">

  <div class="mpp-toggle-button__content"></div>
</label>
